import React, { useEffect, useState } from "react";
import api from "../../services/api";

const moisOptions = [
  { value: 1, label: "Janvier" }, { value: 2, label: "Février" },
  { value: 3, label: "Mars" }, { value: 4, label: "Avril" },
  { value: 5, label: "Mai" }, { value: 6, label: "Juin" },
  { value: 7, label: "Juillet" }, { value: 8, label: "Août" },
  { value: 9, label: "Septembre" }, { value: 10, label: "Octobre" },
  { value: 11, label: "Novembre" }, { value: 12, label: "Décembre" },
];

const BarreProgression = ({ label, nb, total, montant, color }) => {
  const pct = total > 0 ? Math.round((nb / total) * 100) : 0;
  return (
    <div style={{ marginBottom: "0.75rem" }}>
      <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", marginBottom: "4px" }}>
        <span style={{ color: "#374151" }}>{label}</span>
        <span style={{ color, fontWeight: "500" }}>{nb} ({pct}%) — {Number(montant).toLocaleString("fr-FR")} F</span>
      </div>
      <div style={{ backgroundColor: "#f3f4f6", borderRadius: "9999px", height: "8px", overflow: "hidden" }}>
        <div style={{ height: "100%", width: `${pct}%`, backgroundColor: color, borderRadius: "9999px", transition: "width 0.5s ease" }} />
      </div>
    </div>
  );
};

const StatistiquesAdmin = () => {
  const now = new Date();
  const [mois, setMois] = useState(now.getMonth() + 1);
  const [annee, setAnnee] = useState(now.getFullYear());
  const [superviseurs, setSuperviseurs] = useState([]);
  const [supSelectionne, setSupSelectionne] = useState(null);
  const [commerciaux, setCommerciaux] = useState([]);
  const [commercialFiltre, setCommercialFiltre] = useState("tous");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const annees = [];
  for (let y = now.getFullYear(); y >= now.getFullYear() - 2; y--) annees.push(y);

  useEffect(() => {
    api.get("/commercials/dashboard/admin")
      .then(r => {
        const sups = r.data.performance_par_superviseur || [];
        setSuperviseurs(sups);
        if (sups.length > 0) setSupSelectionne(sups[0].id);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!supSelectionne) return;
    api.get(`/superviseurs/${supSelectionne}/commerciaux`)
      .then(r => { setCommerciaux(r.data); setCommercialFiltre("tous"); })
      .catch(() => {});
  }, [supSelectionne]);

  const fetchStats = async () => {
    if (!supSelectionne) return;
    setLoading(true);
    setError("");
    try {
      const comId = commercialFiltre !== "tous" ? `&commercialId=${commercialFiltre}` : "";
      const res = await api.get(`/superviseurs/${supSelectionne}/statistiques?mois=${mois}&annee=${annee}${comId}`);
      setData(res.data);
    } catch (err) {
      setError("Erreur lors du chargement");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (supSelectionne) fetchStats();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [supSelectionne]);

  const moisLabel = moisOptions.find(m => m.value === mois)?.label;
  const supActif = superviseurs.find(s => s.id === supSelectionne);

  return (
    <>
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: "1.5rem", flexWrap: "wrap", gap: "0.75rem" }}>
        <div>
          <h1 style={{ fontSize: "18px", fontWeight: "500", color: "#111827", margin: 0 }}>Statistiques</h1>
          <p style={{ fontSize: "13px", color: "#6b7280", margin: "4px 0 0" }}>Analyse des ventes et remboursements</p>
        </div>
        <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
          <select value={commercialFiltre} onChange={e => setCommercialFiltre(e.target.value)}
            style={{ padding: "0.5rem 0.75rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", outline: "none", background: "white" }}>
            <option value="tous">Tous les commerciaux</option>
            {commerciaux.map(c => <option key={c.id} value={c.id}>{c.prenom} {c.nom}</option>)}
          </select>
          <select value={mois} onChange={e => setMois(Number(e.target.value))}
            style={{ padding: "0.5rem 0.75rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", outline: "none", background: "white" }}>
            {moisOptions.map(m => <option key={m.value} value={m.value}>{m.label}</option>)}
          </select>
          <select value={annee} onChange={e => setAnnee(Number(e.target.value))}
            style={{ padding: "0.5rem 0.75rem", border: "1px solid #e5e7eb", borderRadius: "8px", fontSize: "13px", outline: "none", background: "white" }}>
            {annees.map(y => <option key={y} value={y}>{y}</option>)}
          </select>
          <button onClick={fetchStats} disabled={loading}
            style={{ padding: "0.5rem 1.25rem", background: "linear-gradient(135deg, #7c3aed, #9333ea)", color: "white", fontWeight: "500", fontSize: "13px", borderRadius: "8px", border: "none", cursor: loading ? "not-allowed" : "pointer", opacity: loading ? 0.7 : 1 }}>
            {loading ? "..." : "Afficher"}
          </button>
        </div>
      </div>

      {/* Sélecteur superviseur */}
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginBottom: "1.25rem" }}>
        {superviseurs.map(sup => (
          <button key={sup.id} onClick={() => setSupSelectionne(sup.id)} style={{
            padding: "0.5rem 1rem", borderRadius: "9999px", fontSize: "12px",
            border: supSelectionne === sup.id ? "none" : "1px solid #e5e7eb",
            backgroundColor: supSelectionne === sup.id ? "#7c3aed" : "white",
            color: supSelectionne === sup.id ? "white" : "#6b7280",
            cursor: "pointer"
          }}>{sup.prenom} {sup.nom}</button>
        ))}
      </div>

      {error && <div style={{ marginBottom: "1rem", padding: "0.75rem", backgroundColor: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", color: "#dc2626", fontSize: "13px" }}>{error}</div>}

      {loading ? (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "40vh" }}>
          <div style={{ width: "36px", height: "36px", border: "3px solid #f3e8ff", borderTop: "3px solid #7c3aed", borderRadius: "50%", animation: "spin 1s linear infinite" }} />
        </div>
      ) : data && (
        <>
          <div style={{ fontSize: "13px", color: "#6b7280", marginBottom: "1.25rem" }}>
            {supActif?.prenom} {supActif?.nom} — {moisLabel} {annee}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "1.25rem" }}>
            {/* Section Ventes */}
            <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.25rem" }}>
              <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827", marginBottom: "1rem" }}>💰 Ventes du mois</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "1rem" }}>
                <div style={{ padding: "0.75rem", backgroundColor: "#f9fafb", borderRadius: "10px" }}>
                  <div style={{ fontSize: "11px", color: "#6b7280" }}>Total crédits</div>
                  <div style={{ fontSize: "20px", fontWeight: "500", color: "#7c3aed" }}>{data.ventes?.total_credits || 0}</div>
                </div>
                <div style={{ padding: "0.75rem", backgroundColor: "#f9fafb", borderRadius: "10px" }}>
                  <div style={{ fontSize: "11px", color: "#6b7280" }}>Montant injecté</div>
                  <div style={{ fontSize: "16px", fontWeight: "500", color: "#ea580c" }}>{Number(data.ventes?.montant_total_injecte || 0).toLocaleString("fr-FR")} F</div>
                </div>
              </div>
              <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "0.75rem", fontWeight: "500" }}>Répartition par tranche</div>
              {[
                { label: "≤ 25 000 F", nb: data.ventes?.repartition_tranches?.tranche_25k || 0, color: "#185FA5" },
                { label: "≤ 50 000 F", nb: data.ventes?.repartition_tranches?.tranche_50k || 0, color: "#0891b2" },
                { label: "≤ 75 000 F", nb: data.ventes?.repartition_tranches?.tranche_75k || 0, color: "#7c3aed" },
                { label: "≤ 100 000 F", nb: data.ventes?.repartition_tranches?.tranche_100k || 0, color: "#ea580c" },
              ].map((t, i) => {
                const total = data.ventes?.total_credits || 0;
                const pct = total > 0 ? Math.round((t.nb / total) * 100) : 0;
                return (
                  <div key={i} style={{ marginBottom: "0.5rem" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", marginBottom: "3px" }}>
                      <span style={{ color: "#374151" }}>{t.label}</span>
                      <span style={{ color: t.color, fontWeight: "500" }}>{t.nb} crédit(s) ({pct}%)</span>
                    </div>
                    <div style={{ backgroundColor: "#f3f4f6", borderRadius: "9999px", height: "6px" }}>
                      <div style={{ height: "100%", width: `${pct}%`, backgroundColor: t.color, borderRadius: "9999px" }} />
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Section Remboursements */}
            <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.25rem" }}>
              <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827", marginBottom: "1rem" }}>📊 Remboursements</div>
              <div style={{ padding: "0.75rem", backgroundColor: "#f9fafb", borderRadius: "10px", marginBottom: "1rem" }}>
                <div style={{ fontSize: "11px", color: "#6b7280" }}>Total remboursés ce mois</div>
                <div style={{ fontSize: "20px", fontWeight: "500", color: "#0f6e56" }}>{data.remboursements?.total_rembourses || 0}</div>
              </div>
              <BarreProgression label="À temps" nb={data.remboursements?.nb_a_temps || 0} total={data.remboursements?.total_rembourses || 0} montant={data.remboursements?.montant_a_temps || 0} color="#16a34a" />
              <BarreProgression label="Retard <24h" nb={data.remboursements?.nb_retard_24h || 0} total={data.remboursements?.total_rembourses || 0} montant={data.remboursements?.montant_retard_24h || 0} color="#ca8a04" />
              <BarreProgression label="Retard >24h" nb={data.remboursements?.nb_retard_sup_24h || 0} total={data.remboursements?.total_rembourses || 0} montant={data.remboursements?.montant_retard_sup_24h || 0} color="#ea580c" />
              <BarreProgression label="Tardifs" nb={data.remboursements?.nb_tardifs || 0} total={data.remboursements?.total_rembourses || 0} montant={data.remboursements?.montant_tardifs || 0} color="#dc2626" />
            </div>

            {/* Section Pénalités */}
            <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.25rem" }}>
              <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827", marginBottom: "1rem" }}>⚠️ Pénalités en cours</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px" }}>
                <div style={{ padding: "0.75rem", backgroundColor: "#fef2f2", borderRadius: "10px" }}>
                  <div style={{ fontSize: "11px", color: "#9ca3af" }}>Crédits non remb.</div>
                  <div style={{ fontSize: "20px", fontWeight: "500", color: "#dc2626" }}>{data.penalites?.nb_credits_non_rembourses || 0}</div>
                </div>
                <div style={{ padding: "0.75rem", backgroundColor: "#fef2f2", borderRadius: "10px" }}>
                  <div style={{ fontSize: "11px", color: "#9ca3af" }}>Pénalités accumulées</div>
                  <div style={{ fontSize: "16px", fontWeight: "500", color: "#dc2626" }}>{Number(data.penalites?.total_penalites_accumulees || 0).toLocaleString("fr-FR")} F</div>
                </div>
                <div style={{ padding: "0.75rem", backgroundColor: "#fff7ed", borderRadius: "10px", gridColumn: "1/-1" }}>
                  <div style={{ fontSize: "11px", color: "#9ca3af" }}>Montant total dû</div>
                  <div style={{ fontSize: "20px", fontWeight: "500", color: "#ea580c" }}>{Number(data.penalites?.total_montant_du || 0).toLocaleString("fr-FR")} F</div>
                </div>
              </div>
            </div>
          </div>

          {/* Section Clients */}
            <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.25rem" }}>
              <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827", marginBottom: "1rem" }}>👥 Clients</div>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", marginBottom: "1rem" }}>
                <div style={{ padding: "0.75rem", backgroundColor: "#f9fafb", borderRadius: "10px" }}>
                  <div style={{ fontSize: "11px", color: "#6b7280" }}>Total clients actifs</div>
                  <div style={{ fontSize: "20px", fontWeight: "500", color: "#111827" }}>{data.clients?.total_actifs || 0}</div>
                </div>
                <div style={{ padding: "0.75rem", backgroundColor: "#E6F1FB", borderRadius: "10px" }}>
                  <div style={{ fontSize: "11px", color: "#185FA5" }}>Actifs ce mois</div>
                  <div style={{ fontSize: "20px", fontWeight: "500", color: "#185FA5" }}>{data.clients?.nb_actifs_mois || 0} <span style={{ fontSize: "13px" }}>({data.clients?.taux_actifs_mois || 0}%)</span></div>
                </div>
              </div>
              <div style={{ fontSize: "12px", color: "#6b7280", marginBottom: "0.75rem", fontWeight: "500" }}>Répartition par statut</div>
              {[
                { label: "Très fiable", nb: data.clients?.nb_tres_fiable || 0, color: "#16a34a" },
                { label: "Fiable",      nb: data.clients?.nb_fiable || 0,      color: "#ca8a04" },
                { label: "À risque",    nb: data.clients?.nb_a_risque || 0,    color: "#ea580c" },
                { label: "Bloqué",      nb: data.clients?.nb_bloque || 0,      color: "#dc2626" },
              ].map((s, i) => {
                const total = data.clients?.total_actifs || 0;
                const pct = total > 0 ? Math.round((s.nb / total) * 100) : 0;
                return (
                  <div key={i} style={{ marginBottom: "0.5rem" }}>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: "12px", marginBottom: "3px" }}>
                      <span style={{ color: "#374151" }}>{s.label}</span>
                      <span style={{ color: s.color, fontWeight: "500" }}>{s.nb} ({pct}%)</span>
                    </div>
                    <div style={{ backgroundColor: "#f3f4f6", borderRadius: "9999px", height: "6px" }}>
                      <div style={{ height: "100%", width: `${pct}%`, backgroundColor: s.color, borderRadius: "9999px" }} />
                    </div>
                  </div>
                );
              })}
            </div>

          {/* Section Classements */}
            <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", padding: "1.25rem", marginTop: "1.25rem" }}>
              <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827", marginBottom: "1rem" }}>🏆 Performance commerciaux</div>
              
              {data.meilleur_jour_global && (
                <div style={{ padding: "0.75rem 1rem", backgroundColor: "#f0fdf4", borderRadius: "10px", marginBottom: "1rem", display: "flex", alignItems: "center", gap: "8px" }}>
                  <span style={{ fontSize: "16px" }}>📅</span>
                  <span style={{ fontSize: "13px", color: "#0f6e56" }}>
                    Meilleur jour global : <strong>{data.meilleur_jour_global.jour}</strong> ({data.meilleur_jour_global.nb_credits} crédit(s))
                  </span>
                </div>
              )}

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "1rem" }}>
                {/* Classement par montant mobilisé */}
                <div>
                  <div style={{ fontSize: "12px", color: "#6b7280", fontWeight: "500", marginBottom: "0.75rem" }}>Par montant injecté</div>
                  {[...( data.par_commercial || [])].sort((a, b) => b.montant_injecte - a.montant_injecte).map((com, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                      <div style={{ width: "20px", height: "20px", borderRadius: "50%", backgroundColor: i === 0 ? "#fbbf24" : i === 1 ? "#9ca3af" : "#d97706", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", fontWeight: "600", color: "white", flexShrink: 0 }}>
                        {i + 1}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: "12px", fontWeight: "500", color: "#111827" }}>{com.prenom} {com.nom}</div>
                        <div style={{ fontSize: "11px", color: "#ea580c" }}>{Number(com.montant_injecte).toLocaleString("fr-FR")} F</div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Classement par taux de remboursement */}
                <div>
                  <div style={{ fontSize: "12px", color: "#6b7280", fontWeight: "500", marginBottom: "0.75rem" }}>Par taux de remboursement</div>
                  {[...(data.par_commercial || [])].sort((a, b) => b.taux_remboursement - a.taux_remboursement).map((com, i) => (
                    <div key={i} style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "8px" }}>
                      <div style={{ width: "20px", height: "20px", borderRadius: "50%", backgroundColor: i === 0 ? "#fbbf24" : i === 1 ? "#9ca3af" : "#d97706", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "10px", fontWeight: "600", color: "white", flexShrink: 0 }}>
                        {i + 1}
                      </div>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={{ fontSize: "12px", fontWeight: "500", color: "#111827" }}>{com.prenom} {com.nom}</div>
                        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                          <div style={{ flex: 1, backgroundColor: "#f3f4f6", borderRadius: "9999px", height: "4px" }}>
                            <div style={{ height: "100%", width: `${com.taux_remboursement}%`, backgroundColor: "#16a34a", borderRadius: "9999px" }} />
                          </div>
                          <span style={{ fontSize: "11px", color: "#16a34a", fontWeight: "500" }}>{com.taux_remboursement}%</span>
                        </div>
                        {com.meilleur_jour && (
                          <div style={{ fontSize: "10px", color: "#9ca3af" }}>Meilleur jour : {com.meilleur_jour.jour}</div>
                        )}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          {/* Tableau par commercial */}
          {data.par_commercial?.length > 0 && commercialFiltre === "tous" && (
            <div style={{ backgroundColor: "white", border: "0.5px solid #e5e7eb", borderRadius: "16px", overflow: "hidden", marginTop: "1.25rem" }}>
              <div style={{ padding: "1rem 1.25rem", borderBottom: "0.5px solid #e5e7eb" }}>
                <div style={{ fontSize: "14px", fontWeight: "500", color: "#111827" }}>Détail par commercial</div>
              </div>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "13px" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f9fafb" }}>
                      {["Commercial", "Crédits", "Montant injecté", "≤25k", "≤50k", "≤75k", "≤100k", "Remb.", "Non remb."].map(h => (
                        <th key={h} style={{ padding: "0.75rem 1rem", textAlign: "left", fontSize: "11px", color: "#6b7280", fontWeight: "500", whiteSpace: "nowrap" }}>{h}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {data.par_commercial.map((com, i) => (
                      <tr key={i} style={{ borderTop: "0.5px solid #f3f4f6" }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = "#f9fafb"}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = "transparent"}>
                        <td style={{ padding: "0.75rem 1rem", fontWeight: "500", color: "#111827" }}>{com.prenom} {com.nom}</td>
                        <td style={{ padding: "0.75rem 1rem" }}>{com.total_credits}</td>
                        <td style={{ padding: "0.75rem 1rem", color: "#ea580c", whiteSpace: "nowrap" }}>{Number(com.montant_injecte).toLocaleString("fr-FR")} F</td>
                        <td style={{ padding: "0.75rem 1rem" }}><span style={{ backgroundColor: "#E6F1FB", color: "#185FA5", padding: "2px 6px", borderRadius: "4px" }}>{com.repartition_tranches?.tranche_25k || 0}</span></td>
                        <td style={{ padding: "0.75rem 1rem" }}><span style={{ backgroundColor: "#ecfeff", color: "#0891b2", padding: "2px 6px", borderRadius: "4px" }}>{com.repartition_tranches?.tranche_50k || 0}</span></td>
                        <td style={{ padding: "0.75rem 1rem" }}><span style={{ backgroundColor: "#f3e8ff", color: "#7c3aed", padding: "2px 6px", borderRadius: "4px" }}>{com.repartition_tranches?.tranche_75k || 0}</span></td>
                        <td style={{ padding: "0.75rem 1rem" }}><span style={{ backgroundColor: "#fff7ed", color: "#ea580c", padding: "2px 6px", borderRadius: "4px" }}>{com.repartition_tranches?.tranche_100k || 0}</span></td>
                        <td style={{ padding: "0.75rem 1rem", color: "#16a34a" }}>{com.total_rembourses}</td>
                        <td style={{ padding: "0.75rem 1rem", color: com.total_non_rembourses > 0 ? "#dc2626" : "#9ca3af" }}>{com.total_non_rembourses}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default StatistiquesAdmin;